import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  detalharMensagemAnteriorPessoa,
  detalharMensagemAnteriorRL,
  detalharMensagemPessoa,
  detalharMensagemProximaPessoa,
  detalharMensagemProximaRL,
  detalharMensagemRL,
} from '../../api/mensagemAPI';
import { RootState } from '../../app/store';
import * as mensagens from '../../common/Mensagens';

export interface CaixaMensagemDetalheState {
  mensagemDetalhe: any;
  mensagem: string;
  tipoMensagem: string;
  ativarMensagem: boolean;
}

const initialState: CaixaMensagemDetalheState = {
  mensagemDetalhe: null,
  mensagem: '',
  tipoMensagem: '',
  ativarMensagem: false,
};

export const getObterDetalhaMensagemPessoa = createAsyncThunk(
  'caixaMensagemDetalhe/getObterDetalhaMensagemPessoa',
  async (data: any) => {
    switch (data.ponteiroMensagem) {
      case -1:
        return detalharMensagemAnteriorPessoa(data.idPessoa, data.idMensagemPessoa, true);
      case 0:
        return detalharMensagemPessoa(data.idPessoa, data.idMensagemPessoa, true);
      case 1:
        return detalharMensagemProximaPessoa(data.idPessoa, data.idMensagemPessoa, true);
      default:
        return detalharMensagemPessoa(data.idPessoa, data.idMensagemPessoa, true);
    }
  }
);

export const getObterDetalhaMensagemRL = createAsyncThunk(
  'caixaMensagemDetalhe/getObterDetalhaMensagemRL',
  async (data: any) => {
    switch (data.ponteiroMensagem) {
      case -1:
        return detalharMensagemAnteriorRL(data.idPessoa, data.idMensagemPessoa, true);
      case 0:
        return detalharMensagemRL(data.idPessoa, data.idMensagemPessoa, true);
      case 1:
        return detalharMensagemProximaRL(data.idPessoa, data.idMensagemPessoa, true);
      default:
        return detalharMensagemRL(data.idPessoa, data.idMensagemPessoa, true);
    }
  }
);


export const getObterDetalhaMensagemPessoaIdPositiva = createAsyncThunk(
  'caixaMensagemDetalhe/getObterDetalhaMensagemPessoaIdPositiva',
  async (data: any) => {
    switch (data.ponteiroMensagem) {
      case -1:
        return detalharMensagemAnteriorPessoa(data.idPessoa, data.idMensagemPessoa, false);
      case 0:
        return detalharMensagemPessoa(data.idPessoa, data.idMensagemPessoa, false);
      case 1:
        return detalharMensagemProximaPessoa(data.idPessoa, data.idMensagemPessoa, false);
      default:
        return detalharMensagemPessoa(data.idPessoa, data.idMensagemPessoa, false);
    }
  }
);

export const caixaMensagemDetalheSlice = createSlice({
  name: 'caixaMensagemSlice',
  initialState,
  reducers: {
    limpar: (state) => {
      state.mensagemDetalhe = initialState.mensagemDetalhe;
    },
    ativarMensagem: (state, action) => {
      state.ativarMensagem = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getObterDetalhaMensagemPessoa.fulfilled, (state, action) => {
      if (action.payload) {
        state.mensagemDetalhe = action.payload;
      } else {
        state.tipoMensagem = 'warning';
        state.mensagem = mensagens.MSG_FIM_NAVEGACAO_MENSAGENS;
        state.ativarMensagem = true;
      }
    });
    builder.addCase(getObterDetalhaMensagemRL.fulfilled, (state, action) => {
      if (action.payload) {
        state.mensagemDetalhe = action.payload;
      } else {
        state.tipoMensagem = 'warning';
        state.mensagem = mensagens.MSG_FIM_NAVEGACAO_MENSAGENS;
        state.ativarMensagem = true;
      }
    });    
    builder.addCase(getObterDetalhaMensagemPessoaIdPositiva.fulfilled, (state, action) => {
      if (action.payload) {
        state.mensagemDetalhe = action.payload;
      } else {
        state.tipoMensagem = 'warning';
        state.mensagem = mensagens.MSG_FIM_NAVEGACAO_MENSAGENS;
        state.ativarMensagem = true;
      }
    });
  },
});

export const { limpar, ativarMensagem, alterarMensagem } = caixaMensagemDetalheSlice.actions;

export const selectMensagemDetalhe = (state: RootState) =>
  state.caixaMensagemDetalhe.mensagemDetalhe;

export const selectState = (state: RootState) => state.caixaMensagemDetalhe;

export default caixaMensagemDetalheSlice.reducer;
